import {
  Alert,
  Card,
  Flex,
  JsonViewer,
  SimpleTable,
  ThemeChanger,
  ThemeSwitcher,
  Typography,
} from "djuno-design";
import { Link } from "react-router-dom";
import { ddpPageUrl } from "../urls";
import ExpandableCard from "../components/ExpandableCard";
import { GithubTypesLink } from "./../urls";

const { Title, Text } = Typography;

const ThemeChangersPage = () => {
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Flex direction="col">
        <Flex direction="col">
          <Title level={4}>ThemeChanger and ThemeSwitcher</Title>
          <Text size="sm" style={{ marginBottom: 30 }}>
            The ThemeChanger and ThemeSwitcher components allow users to switch
            between different themes (light, dark, or system default) within
            your application. Both components use the useDjunoDesign hook to
            interact with the theme context, and dynamically change the
            appearance of the application based on the selected theme mode.
          </Text>
          <Alert
            uiType="info"
            showIcon
            message={
              <Text size="sm">
                We recommend that you use{" "}
                <Typography.Link size="sm">
                  <Link to={ddpPageUrl}>DjunoDesignProvider</Link>
                </Typography.Link>{" "}
                at the top of your component tree. This will make your app
                management integrated
              </Text>
            }
          />
        </Flex>

        {/* Examples */}
        <Flex direction="col" className="w-full">
          <Title level={5} className="mt-5">
            Examples
          </Title>
          <Flex direction="col" className="gap-4 w-full">
            <ExpandableCard
              codeViewerProps={{
                code: ThemeChangerExample1,
              }}
            >
              <Flex items="center" className="gap-5">
                <Flex direction="col" items="center" className="p-4 gap-5">
                  <ThemeChanger />
                  <Text size="sm">{`<ThemeChanger/>`}</Text>
                </Flex>
                <Flex direction="col" items="center" className="p-4 gap-5">
                  <ThemeSwitcher />
                  <Text size="sm">{`<ThemeSwitcher/>`}</Text>
                </Flex>
              </Flex>
            </ExpandableCard>
          </Flex>
        </Flex>

        {/* API */}
        <Flex direction="col" className="w-full mt-5">
          <Title level={5}>API</Title>
          <Flex direction="col" className="gap-1 w-full">
            <Card id="API">
              <SimpleTable>
                <SimpleTable.Head>
                  <SimpleTable.TH>Property</SimpleTable.TH>
                  <SimpleTable.TH>Description</SimpleTable.TH>
                  <SimpleTable.TH>Type</SimpleTable.TH>
                  <SimpleTable.TH>Default</SimpleTable.TH>
                </SimpleTable.Head>
                <SimpleTable.Body>
                  {/* anchor */}
                  <SimpleTable.Row>
                    <SimpleTable.TD>
                      <Text size="sm">anchor</Text>
                    </SimpleTable.TD>
                    <SimpleTable.TD>
                      <Text size="sm">
                        {" "}
                        the properties related to the anchor positioning or
                        alignment of UI component
                      </Text>
                    </SimpleTable.TD>
                    <SimpleTable.TD>
                      <Typography.Link
                        target="_blank"
                        href={GithubTypesLink + "IDropdown.ts#L67"}
                        size="xs"
                        code
                      >
                        AnchorProps
                      </Typography.Link>
                    </SimpleTable.TD>
                    <SimpleTable.TD></SimpleTable.TD>
                  </SimpleTable.Row>
                  {/* itemsClassName */}
                  <SimpleTable.Row>
                    <SimpleTable.TD>
                      <Text size="sm">itemsClassName</Text>
                    </SimpleTable.TD>
                    <SimpleTable.TD>
                      <Text size="sm">
                        Additional classes to apply to the items within the
                        ThemeChanger.
                      </Text>
                    </SimpleTable.TD>
                    <SimpleTable.TD>
                      <Text size="xs" code>
                        string
                      </Text>
                    </SimpleTable.TD>
                    <SimpleTable.TD>
                      <Text size="sm"></Text>
                    </SimpleTable.TD>
                  </SimpleTable.Row>
                </SimpleTable.Body>
              </SimpleTable>
            </Card>
          </Flex>
        </Flex>
      </Flex>
    </div>
  );
};

const ThemeChangerExample1 = `<Flex items="center" className="gap-5">
  <Flex direction="col" items="center" className="p-4 gap-5">
    <ThemeChanger />
    <Text size="sm"><ThemeChanger/></Text>
  </Flex>
  <Flex direction="col" items="center" className="p-4 gap-5">
    <ThemeSwitcher />
    <Text size="sm"><ThemeSwitcher/></Text>
  </Flex>
</Flex>`;

export default ThemeChangersPage;
